(function ($) {
  'use strict';

  /**
   * Warning user if moving away from form with altered inputs
   */
  function NavigationWarning () {
  }

  NavigationWarning.prototype = {

    init: function () {
      this.$formHasChanged = false;
      this.$form = $('.js-form');

      if (this.$form.length !== 1) {
        return;
      }

      this.$links = $('a:not([href^="#"])');
      this.$links.on('click', $.proxy(this.onNavigation, this));

      this.$formInputs = this.$form.find('js-form-input input, js-form-input textarea');
      this.$formSelects = this.$form.find('js-form-input selects');

      this.$formInputs.on('input change', $.proxy(this.onFormChange, this));
    },

    onFormChange: function () {
      // Set the variable
      this.$formHasChanged = true;
      // Remove event listener
      this.$formInputs.off('input change');
    },

    onNavigation: function (e) {
      if (this.$formHasChanged) {
        e.preventDefault();

        var dialog = new Framework.Modal({
          'mainEl': document.getElementById('container'), // The element to insert the modal HTML after
          'id': 'navigationWarning', // A unique Id for this modal
          'title': 'There are unsaved changes on the current page',
          'description': 'If you leave now, you will lose any changes. Click ‘Cancel’ to stay on the current page, or ‘Continue’ to leave this page and lose your changes.',
          'buttons': [
            {
              'text': 'Cancel',
              'className': 'btn--outline',
              'close': true // Whether or not this button will close the modal
            },
            {
              'text': 'Continue',
              'callback': function () {
                // Continue to the link URL
                var linkUrl = $(e.target).attr('href');
                window.location = linkUrl;
              }
            }
          ]
        });

        // Show the dialog
        dialog.show();
      }
    }
  };

  this.NavigationWarning = NavigationWarning;
}).call(Framework, jQuery);
